import SearchWorker from './search-worker?worker';

export function createWorker(): Worker {
  return new SearchWorker();
}
